module.exports = __webpack_public_path__ + "static/media/car-transparent.7f4a2de6.png";